module.exports = __webpack_public_path__ + "static/media/icon-send.7a95a144.svg";